<template>
  <div class="shopItemDetailOption" :class="{isActiveSubOption: getActiveSubOption}">
    <div class="optionWrapper">
      <button type="button" class="btnCloseOption" @click.stop="close"></button>
      <div class="optionTabs">
        <button
          v-for="(tab, index) in optionTab"
          :key="index"
          type="button"
          class="tabItem"
          :style="isActive(tab.uniqueId) ? getDefaultBtnStyle : getDefaultBtnStyleReverse"
          @click="setActiveTab(tab.uniqueId)">
          <!-- <i v-if="requiredStkr && (tab.requiredStatus !== '0')" :data-status="tab.requiredStatus" class="optionStatus"></i> -->
          <span v-if="requiredStkr && tab.isRequired" :data-status="tab.requiredStatus" class="requiredStkr">{{ locale.required }}</span>
          {{ tab.name[lang] }}
          <span v-if="tab.requiredMessage" class="notranslate">({{ tab.requiredMessage }})</span>
          <span v-else-if="tab.quantityMessage" class="notranslate">({{ tab.quantityMessage }})</span>
        </button>
      </div>
      <Options
        :locale="locale"
        :lang="lang"
        :options="options"
        :cartOptions="cartOptions"
        :shopItemId="shopItemId"
        :activeOptionId="activeOptionId"
        :shopResponsive="shopResponsive"
        class="optionBox" />
      <div class="btns">
        <button v-if="!isAuth"
          type="button"
          class="btn btnCart notranslate"
          :style="getDefaultBtnStyle"
          @click="close">
          {{ locale.confirm }}
        </button>
        <button v-else-if="!isAvailable"
          type="button"
          class="btn btnCart notranslate"
          @click.stop="close">
          {{ locale.not_available }}
        </button>
        <button v-else-if="status"
          type="button"
          class="btn btnCart"
          @click.stop="close">
          {{ status[lang] }}
        </button>
        <button v-else-if="insufficient"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ locale.insufficient_quantity }}
        </button>
        <button v-else-if="categoryItemLimit"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ categoryItemLimit }}
        </button>
        <button v-else-if="timeIsExpired"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ locale.over_order_time }}
        </button>
        <button v-else
          type="button"
          class="btn btnCart notranslate"
          :style="getDefaultBtnStyle"
          :disabled="!isAuth || !isValid || !isAvailable"
          @click="apply">
          {{ locale.complete_select }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import UNIQUE from '@/common/unique'
import Options from './Options'
import ItemQuantity from './ItemQuantity'
import AvailableTable from '@/components/Util/AvailableTable'

export default {
  name: 'shopItemDetailOptions',
  props: [
    'locale',
    'lang',
    'shopResponsive',
    'isAvailable',
    'status',
    'isValid',
    'shopItemId',
    'detailOption',
    'cartOptions',
    'insufficient',
    'categoryItemLimit',
    'timeIsExpired'
  ],
  components: {
    Carousel,
    Slide,
    Options,
    ItemQuantity,
    AvailableTable
  },
  computed: {
    requiredStkr () {
      const shopPageId = this.$route.params.shopPageId
      const shopSettings = this.$store.getters['shop/getShopSettings'](shopPageId)
      return shopSettings && !shopSettings.hiddenOptionRequirement
    },
    options () {
      return this.$store.getters['shop/getDetailOptionArray']
    },
    optionTab () {
      const options = this.options
      return options.map(item => {
        return {
          ...item,
          quantityMessage: this.getQuantityMessage(item),
          requiredMessage: this.getRequiredMessage(item),
          requiredStatus: this.getRequiredStatus(item)
        }
      })
    },
    getActiveSubOption () {
      return this.$store.getters['shop/getActiveSubOption']
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    getDefaultBtnStyleReverse () {
      return this.$store.getters['common/getDefaultBtnStyleReverse']
    },
    isAuth () {
      const isAuth = this.$store.getters['authentication/isAuth']
      return isAuth
    }
  },
  mounted () {
    if (this.options) {
      this.activeOptionId = this.options && this.options[0].uniqueId
    }
  },
  beforeDestroy () {
    this.$store.commit('shop/setActiveSubOption', null)
  },
  data () {
    return {
      activeOptionId: ''
    }
  },
  methods: {
    getQuantityMessage (item) {
      const min = item.min
      const max = item.max
      return  min === max
        ? this.locale.shop_condition_quantity_specific.replace('{var}', max) // N개 선택
        : this.locale.shop_condition_quantity_range.replace('{min}', min).replace('{max}', max) // N~M개 선택
    },
    getRequiredMessage (item) {
      const isRequired = item.isRequired
      const uniqueId = item.uniqueId
      const detailOption = this.detailOption[uniqueId]
      return this.getActiveSubOption
        ? this.locale.option_select
        : isRequired
          ? detailOption && detailOption.isValid ? this.locale.complete_select : ''
          : detailOption && detailOption.isValid && detailOption.optionItems.length > 0 ? this.locale.complete_select : ''
    },
    getRequiredStatus (item) {
      const isRequired = item.isRequired
      const uniqueId = item.uniqueId
      const detailOption = this.detailOption[uniqueId]
      let status = 0 // 선택사항(필수아님)
      if (isRequired) status = 1 // 필수사항
      if (isRequired && detailOption && detailOption.isValid) status = 2 // 필수사항 선택완료
      return `${status}`
    },
    setActiveTab (uniqueId) {
      this.activeOptionId = uniqueId
      this.$store.commit('shop/setActiveSubOption', null)
    },
    isActive (uniqueId) {
      return this.activeOptionId === uniqueId
    },
    close ($event) {
      this.$emit('close', $event)
    },
    apply (e) {
      e.stopPropagation()
      this.$emit('applyOption')
    }
  }
}
</script>

<style lang="scss" scoped>
.shopItemDetailOption {
  .requiredStkr {
    margin-left: 0;
    margin-right: 4px;
  }
}
</style>
